export default __webpack_public_path__ + "static/media/img1.93500d5f.jpg";